import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { SimState } from '../../@types/State';
import { getGameState } from '../../helpers/SimStateCalculator';

interface Props {
  simState: SimState;
}

const HomesCalculations: React.FC<Props> = ({ simState }) => {
  const [minHomes, setMinHomes] = useState<number | undefined>(undefined);
  const [maxHomes, setMaxHomes] = useState<number | undefined>(undefined);
  useEffect(() => {
    setMinHomes(undefined);
    setMaxHomes(undefined);
  }, []);

  const handleCalculate = () => {
    handleMaxHomesSimulation();
    handleMinHomesSimulation();
  };
  const handleMaxHomesSimulation = () => {
    setMinHomes(undefined);
    let result = 0;
    const tempState: SimState = JSON.parse(JSON.stringify(simState));
    tempState.buildPercentages.homes = 0;
    let calcs = getGameState(tempState);
    if (calcs.calculatedEconomy.jobsPerformedPcnt === 100) {
      setMinHomes(tempState.buildPercentages.homes);
    }
    while (
      calcs.calculatedEconomy.jobsPerformedPcnt < 100 &&
      calcs.calculatedEconomy.jobsPerformedPcnt > 0
    ) {
      tempState.buildPercentages.homes += 0.25;
      calcs = getGameState(tempState);
      result = tempState.buildPercentages.homes;
    }
    setMinHomes(result);
  };

  const handleMinHomesSimulation = () => {
    setMaxHomes(undefined);
    let result = 0;
    const tempState: SimState = JSON.parse(JSON.stringify(simState));
    tempState.buildPercentages.homes = 0;
    let calcs = getGameState(tempState);
    if (calcs.calculatedEconomy.unfilledJobs <= 30) {
      setMaxHomes(tempState.buildPercentages.homes);
    }
    while (calcs.calculatedEconomy.unfilledJobs > 30) {
      tempState.buildPercentages.homes += 0.25;
      calcs = getGameState(tempState);
      result = tempState.buildPercentages.homes;
    }
    setMaxHomes(result);
  };

  return (
    <Box mx={2}>
      <Box mb={2}>
        <Button
          variant='outlined'
          size='medium'
          onClick={handleCalculate}
          sx={{ mt: 2 }}
        >
          Calculate
        </Button>{' '}
      </Box>

      <Box mt={2}>
        <Paper elevation={3} sx={{ p: 2 }}>
          <Typography variant='body2' gutterBottom>
            You need {minHomes}% homes to get MAX BE (minimum required workers).
          </Typography>
          <Typography variant='body2' gutterBottom>
            You need {maxHomes}% homes to fill all jobs (max GC per tick)
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};

export default HomesCalculations;
